// src/utils/analytics.js
import posthog from "posthog-js";

const POSTHOG_KEY =
  process.env.REACT_APP_POSTHOG_KEY;

const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST ||
  "https://us.i.posthog.com";

export function initAnalytics() {
  if (!POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,

    // Track page changes throughout the React app
    capture_pageview: "history_change",
    capture_pageleave: true,

    // Track clicks and interactions throughout the app,
    // except inside private areas
    autocapture: {
      css_selector_ignorelist: [
        ".ph-no-capture",
        ".ph-no-autocapture",
        "[data-ph-no-autocapture]",
      ],
    },

    // Enable session recordings throughout the app
    disable_session_recording: false,

    // Session replay privacy settings
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: ".ph-mask",

      // Completely block private sections such as chats
      blockSelector: ".ph-no-capture",
    },
  });
}

// Track custom events anywhere in the app
export function track(eventName, properties = {}) {
  if (!POSTHOG_KEY || !eventName) return;

  posthog.capture(eventName, properties);
}

// Identify users after signup or login
export function identifyUser(userId, properties = {}) {
  if (!POSTHOG_KEY || !userId) return;

  posthog.identify(String(userId), properties);
}

// Reset the identified user on logout
export function resetAnalytics() {
  if (!POSTHOG_KEY) return;

  posthog.reset();
}